// import { Injectable } from "@angular/core";
// import {
//   HttpInterceptor,
//   HttpRequest,
//   HttpHandler,
//   HttpEvent,
//   HttpHeaders,
//   HttpErrorResponse,
// } from "@angular/common/http";
// import { from, Observable } from "rxjs";
// import { catchError } from "rxjs/operators";
// import { AuthService } from "../services/auth.service";
// import { Router } from "@angular/router";

// @Injectable()
// export class AuthInterceptor implements HttpInterceptor {
//   constructor(private authService: AuthService, private _router: Router) {}

//   intercept(
//     request: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {
//     return from(
//       this.authService.getToken().then((token) => {
//         //console.log("INTERCEPTOR", token);
//         const headers = new HttpHeaders().set(
//           "Authorization",
//           `Bearer ${token}`
//         );
//         const authRequest = request.clone({ headers });
//         return next
//           .handle(authRequest)
//           .pipe(
//             catchError((err: HttpErrorResponse) => {
//               if (err && (err.status === 401 || err.status === 403)) {
//                 //this._router.navigate(["/login"]);
//               }
//               throw "error in a request " + err.status;
//             })
//           )
//           .toPromise();
//       })
//     );
//   }
// }

import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";

const SIGO_SESSION_KEY = 'SIGO_SESION_ACTUAL';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>,
              next: HttpHandler): Observable<HttpEvent<any>> {

        const idToken = localStorage.getItem(SIGO_SESSION_KEY);

        if (idToken) {
            const cloned = req.clone({
                headers: req.headers.set("Authorization",
                    "Bearer " + idToken)
            });

            return next.handle(cloned);
        }
        else {
            return next.handle(req);
        }
    }
}